import SVG from "../Assests/SVG";
import { Info } from "@mui/icons-material";
import { RouteType } from "./Routesconfig";
import Screen from "./Layout/Screen";
import { AppRoutes } from "./Layout/Routes";

const RetailAppRoutes: RouteType[] = [
  {
    path: AppRoutes.RetailDashbard,
    state: "WasteDashboard",
    element: <Screen.RetailDashboardLayout />,
    sidebarProps: {
      displayText: "Dashboard",
      icon: <SVG.Dashboard />,
    },
    role: "SUPER_ADMIN",
    routeName: "RETAIL",
    child: [
      {
        path: AppRoutes.RetailStocks,
        element: <Screen.StockAndShelfManagement />,
        state: "RetailStock",
        sidebarProps: {
          displayText: "Stock & Shelf Management",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },

      {
        path: AppRoutes.RetailCustomerAnalysis,
        element: <Screen.CustomerAnalysis/>,
        state: "RetailCustomer",
        sidebarProps: {
          displayText: "Customer Analysis",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },
    ],
  },
  {
    path: AppRoutes.RetailReportSummary,
    state: "RetailReportSummary",
    element: <Screen.RetailDashboardLayout />,
    sidebarProps: {
      displayText: "Report Summary",
      icon: <SVG.ReportSummary />,
    },
    role: "SUPER_ADMIN",
    routeName: "RETAIL",
    child: [
      {
        path: AppRoutes.RetailReportStocks,
        element: <Screen.RetailReportSummary />,
        state: "RetailReportStock",
        sidebarProps: {
          displayText: "Stock & Shelf Management",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },

      {
        path: AppRoutes.RetailReportCustomerAnalysis,
        element: <Screen.RetailReportSummary />,
        state: "RetailReportCustomer",
        sidebarProps: {
          displayText: "Customer Analysis",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },
    ],
  },
  {
    path: "/retail/maintenance",
    state: "RetailMaintenance",
    element: <Screen.AgriDashboardLayout />,
    sidebarProps: {
      displayText: "Predictive Maintenance",
      icon: <SVG.PredictiveMaintenance />,
    },
    role: "SUPER_ADMIN",
    routeName: "RETAIL",
    child: [
      {
        path: "/retail/maintenance/asset",
        element: <Screen.AgriDashboardLayout />,
        state: "RetailAsset",
        sidebarProps: {
          displayText: "Asset Overview",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },

      {
        path: "/retail/maintenance/serviceSchedule",
        element: <Screen.AgriDashboardLayout />,
        state: "RetailServiceScheduleTimeline",
        sidebarProps: {
          displayText: "Service Schedule Timeline",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },
    ],
  },
  {
    path: "/retail/subscribe",
    state: "ReatilSubscribe",
    element: <Screen.AgriDashboardLayout />,
    sidebarProps: {
      displayText: "Subscribe Features",
      icon: <SVG.Subscribe />,
    },
    role: "SUPER_ADMIN",
    routeName: "RETAIL",
    child: [
      {
        path: "/retail/subscribe/adddevice",
        element: <Screen.AgriDashboardLayout />,
        state: "RetailAddDevice",
        sidebarProps: {
          displayText: "Add Multiple Device",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },

      {
        path: "/retail/subscribe/impact",
        element: <Screen.AgriDashboardLayout />,
        state: "RetailImpactAnalysis",
        sidebarProps: {
          displayText: "Impact Analysis",
          icon: <Info />,
        },
        role: "SUPER_ADMIN",
        routeName: "RETAIL",
      },
    ],
  },
];

export default RetailAppRoutes;
